import { render, staticRenderFns } from "./ProtectTreatment.vue?vue&type=template&id=34a74baa&scoped=true"
import script from "./ProtectTreatment.vue?vue&type=script&lang=js"
export * from "./ProtectTreatment.vue?vue&type=script&lang=js"
import style0 from "./ProtectTreatment.vue?vue&type=style&index=0&id=34a74baa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a74baa",
  null
  
)

export default component.exports